export default __webpack_public_path__ + "static/girl-nyse-8381ce2454b6aaa764730276c4c2579c.jpg";